<template>
  <header id="vue-header-app">
    <NavBar />
  </header>
</template>

<script>
import NavBar from "./components/Navbar";

export default {
  name: "app",
  components: {
    NavBar,
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App 123",
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue